module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/24631146b84d37efeccb7af83c467659.png";